import universalProvide from "./universalProvide.mjs";
import { PROVIDE_KEY } from "./constants.mjs";
export default function provideOptions(app, options) {
  universalProvide(app, PROVIDE_KEY, options);
}
